var map = {
	"./MEW.png": 2898,
	"./aave.jpeg": 9265,
	"./aeternity.png": 4647,
	"./aion.png": 447,
	"./aktionariat.png": 3298,
	"./atomic.png": 7255,
	"./atwallet.png": 3506,
	"./autherum.png": 450,
	"./banner.png": 14,
	"./banner2.jpeg": 4168,
	"./binance.png": 618,
	"./bitpay.jpeg": 2531,
	"./blockchain.png": 1648,
	"./bnb.png": 325,
	"./callisto.png": 6515,
	"./check.gif": 5726,
	"./coinbase.jpeg": 3475,
	"./coinomi.png": 261,
	"./cosmos.png": 2859,
	"./crypto.jpeg": 5028,
	"./digitex.png": 5402,
	"./discord.svg": 9944,
	"./eidoo.png": 9591,
	"./elrond.jpeg": 1350,
	"./enjin.png": 4488,
	"./ethereum-classic.png": 8702,
	"./exodus.jpeg": 6722,
	"./exodus.png": 616,
	"./filecoin.png": 8699,
	"./fio.png": 3089,
	"./formatic.png": 5936,
	"./github.svg": 6002,
	"./gochain.png": 9303,
	"./guard.png": 3276,
	"./guarda.jpeg": 555,
	"./harmony.jpeg": 7743,
	"./icon.png": 286,
	"./iotex.png": 2615,
	"./kardia.jpeg": 7938,
	"./kava.png": 4364,
	"./kin.png": 8307,
	"./ledger.png": 174,
	"./logo.svg": 2835,
	"./luno.jpeg": 1849,
	"./metamask.png": 8843,
	"./nano.png": 8244,
	"./nebulas.png": 4583,
	"./nimiq.png": 8787,
	"./ontology.png": 2014,
	"./parsiq.jpeg": 6785,
	"./paxful.png": 6431,
	"./phantom.jpeg": 4577,
	"./poa.png": 3510,
	"./polkadot.png": 5131,
	"./portis.png": 8668,
	"./qrcode.png": 7869,
	"./safepal.png": 9485,
	"./satoshi.png": 1469,
	"./solana.png": 3445,
	"./sollet.png": 7935,
	"./stellar.png": 6927,
	"./telegram.svg": 351,
	"./tezos.png": 5890,
	"./theta.png": 5968,
	"./thundertoken.png": 7510,
	"./tomo.png": 5848,
	"./tron.png": 6673,
	"./trustwallet-banner.jpeg": 2377,
	"./trustwallet.png": 9414,
	"./twitter.svg": 7751,
	"./wanchain.png": 6353,
	"./waves.png": 5920,
	"./xrp.png": 905,
	"./zilliqa.png": 5499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;